import React, { CSSProperties, useRef, useState } from 'react';

interface CLTooltipProps {
  content: string | null | undefined;
  children: React.ReactNode;
  className?: string;
  position?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-left';
  isHtmlContent?: boolean;
}

export default function CLTooltip({
  content,
  children,
  className = '',
  position = 'top',
  isHtmlContent = false
}: CLTooltipProps) {
  // Variables
  const [show, setShow] = useState(false);
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const handleMouseOver = () => setShow(true);
  const handleMouseOut = () => setShow(false);

  // Compute positioning styles based on `position` prop
  const tooltipStyle: CSSProperties = {
    position: 'absolute',
    whiteSpace: 'nowrap',
    zIndex: 10
  };

  switch (position) {
    case 'top':
      tooltipStyle.bottom = '120%';
      tooltipStyle.left = '50%';
      tooltipStyle.transform = 'translateX(-50%)';
      break;
    case 'bottom':
      tooltipStyle.top = '120%';
      tooltipStyle.left = '50%';
      tooltipStyle.transform = 'translateX(-50%)';
      break;
    case 'left':
      tooltipStyle.right = '130%';
      tooltipStyle.top = '40%';
      tooltipStyle.transform = 'translateY(-50%)';
      break;
    case 'top-left':
      tooltipStyle.right = '180%';
      tooltipStyle.top = '-20%';
      break;
    case 'right':
      tooltipStyle.left = '120%';
      tooltipStyle.top = '50%';
      tooltipStyle.transform = 'translateY(-50%)';
      break;
    case 'bottom-left':
      tooltipStyle.top = '120%';
      tooltipStyle.left = '0';
      // no transform, stays flush left
      break;
    case 'bottom-right':
      tooltipStyle.top = '120%';
      tooltipStyle.right = '0';
      // no transform, stays flush right
      break;
    default:
      // fallback to top
      tooltipStyle.bottom = '120%';
      tooltipStyle.left = '50%';
      tooltipStyle.transform = 'translateX(-50%)';
  }

  return (
    <div
      className={`relative inline-block ${className}`}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseOut}
    >
      <div ref={tooltipRef} className="w-full h-full">
        {children}
      </div>
      {show && content && (
        <div
          style={tooltipStyle}
          className="px-2 py-1  bg-gray-700 text-white rounded text-sm text-center z-10 whitespace-nowrap"
        >
          {isHtmlContent ? (
            <div dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            content
          )}
        </div>
      )}
    </div>
  );
}
